import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-collapse-panel',
  templateUrl: './collapse-panel.component.html',
  styleUrl: './collapse-panel.component.scss',
})
export class CollapsePanelComponent implements OnInit {
  @Input() open = true;
  @Input() startsOpened = false;
  @Input() title = '';
  @Input() variant: 'default' | 'dashboard' = 'default';
  @Output() openChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  ngOnInit(): void {
    this.open = this.startsOpened;
  }

  toggleOpen() {
    this.open = !this.open;
    this.openChange.emit(this.open);
  }

  openPanel() {
    this.open = true;
    this.openChange.emit(this.open);
  }

  closePanel() {
    this.open = false;
    this.openChange.emit(this.open);
  }
}
